import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";
import logo from '../../assets/fonts/jc-logo.png';
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 65,
    paddingBottom: 65,
    paddingHorizontal: 20,
    fontFamily:'Helvetica',
  },
  brbr:{
  	marginBottom:'10',
  },
  upup:{
    marginTop:'20',
    fontSize:'15',
  },
    mRight:{
     paddingLeft:'5',
  },
  pkg1:{
    marginTop:'20',
    minWidth:'100%',
    paddingRight:'25',
    borderBottom:'1 solid black',
  },
  pkg2:{
    marginTop:'40',
    minWidth:'100%',
    paddingRight:'25',
    borderBottom:'1 solid black',
  },
  box: {
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginTop:'30',
  },
  noteBox: {
      marginTop:'5',
  },
  noteText:{
    fontSize:'13',
    paddingLeft:'10',
  },
  leftPart: {
    	minWidth:'50%',
    	maxWidth:'50%',
  },
  innerLeftPart2: {
    minWidth:'45%',
    maxWidth:'45%',
    alignItems:'flex-start',
    fontSize:'8',
  },
  innerRightPart2: {
    minWidth:'50%',
    maxWidth:'50%',
    alignItems:'flex-start',
  },
  rightPart: {
    	minWidth:'50%',
        maxWidth:'60%',
    	marginLeft:'5'
  },
  tblTitle : {
    fontSize:'9',
    marginBottom: '15',
    fontFamily:'Helvetica-Bold',
  },
  itemTitle : {
    fontSize:'9',
    marginTop: '25',
  },
  itemTblHeader:{
    marginTop: '20',
    fontSize:'9',
  },

  
  tableItems:{
      display:'flex',
      flexDirection: 'row',   
      borderBottom: '1',
      marginBottom: '4',
  },
  header1: {
    	minWidth:'85%',
        fontSize: '16',
  },header2: {
    	minWidth:'15%',
        fontSize: '16',
  },
  item1: {
    	minWidth:'85%',
        maxWidth:'85%',
        fontSize: '7',
  },
  item2: {
        fontSize: '7',
  },
  rightAlign:{
    minWidth:'100%',
    paddingRight:'50',
    alignItems:'flex-end',
  },
  paymentInfo: {
        display: 'flex',
        flexDirection: 'row',
      	justifyContent:'flex-start',
    	marginBottom: '5',
  },

  	cvItems:{
      marginTop: '2',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start'
    },
  
	cvTableHeader:{
      marginTop: 5,
      display:'flex',
      flexDirection: 'row',
      // borderTop:'1 solid black',
      justifyContent:'flex-start'
    },
    blackBorderUp: {
      marginTop:'7',
      borderTop:'1 solid black',
     },
    blackBorder:{
     marginTop:'7',
     borderBottom:'1 solid black',
    },
  
    cvTblHeader1:{
        fontSize: 8,
        minWidth:'70%',
        maxWidth:'70%',
    },
    cvTblHeader2:{
        fontSize: 8,
        minWidth:'20%',
        maxWidth:'20%',
        textAlign:'right',
    },
    cvTblHeader3:{
        fontSize: 8,
        minWidth:'25%',
        maxWidth:'25%',
        textAlign:'right',
    },
    cvTblHeader4:{
        fontSize: 8,
        minWidth:'25%',
        maxWidth:'25%',
        textAlign:'right',
    },
      cvTblHeader5:{
        fontSize: 8,
        minWidth:'65%',
        maxWidth:'70%',
        textAlign:'right',
    },
      cvTblHeader6:{
        fontSize: 8,
        minWidth:'35%',
        maxWidth:'35%',
        textAlign:'right',
    },
    cvTblHeader1Bold:{
      fontSize: 8,
      minWidth:'70%',
      maxWidth:'70%',
      fontFamily:'Helvetica-Bold',
    },
    cvTblHeader3Bold:{
      fontSize: 8,
      minWidth:'25%',
      maxWidth:'25%',
      textAlign:'right',
      fontFamily:'Helvetica-Bold',
    },
    cvTblHeader10Bold:{
      fontSize: 9,
      minWidth:'100%',
      maxWidth:'100%',
      fontFamily:'Helvetica-Bold',
    },
  
  
  
  innerBox: {
      fontSize:'12',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginBottom: '5',
  },
  innerLeftPart: {
    	minWidth:'55%',
      maxWidth:'55%',
      alignItems:'flex-start',
      fontSize:'8',
  },
  innerRightPart: {
    	minWidth:'40%',
	    maxWidth:'40%',
      alignItems:'flex-end',
      fontSize:'8',
  },
  innerPLeftPart: {
    	minWidth:'70%',
      	maxWidth:'70%',
        alignItems:'flex-start',
        fontSize:'8',
  },
  innerPRightPart: {
    	minWidth:'60%',
	    maxWidth:'60%',
        alignItems:'flex-end',
        fontSize:'8',
  },
  innerLeftPayment: {
    	minWidth:'70%',
      	maxWidth:'70%',
        alignItems:'flex-start',
  },
  approvedBy: {
    	minWidth:'72%',
        maxWidth:'72%',
        alignItems:'flex-start',
      	borderTop: '1',
        marginTop: '60',
    	marginLeft:'160',
    	marginRight: '60'
  },
  approver:{
     fontSize:'9',
     fontFamily:'Helvetica-Bold',
  },
  nestedItem1:{
    paddingLeft:'30'
  },
  nestedItem2:{
    paddingLeft:'51'
  },
    nestedItem2:{
    paddingLeft:'42'
  },
  nestedItem3:{
    paddingLeft:'51'
  },
  right:{
    fontSize: '8',
    alignSelf:'flex-end'
  },
  rightName:{
    alignSelf:'flex-end',
  },
  
  wrap:{
     marginBottom: '5',
  }, 
  mRight:{
     paddingLeft:'25',
  },
  title: {
    fontSize:'11',
    textAlign: 'center',
    fontFamily:'Helvetica-Bold',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: '40',
  },
  subtitle: {
    fontSize: '18',
    margin: '12',
    fontFamily: 'Oswald',
  },
  text: {
    margin: '12',
    fontSize: '7',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  image: {
    position: 'absolute',
    width:'40px',
    height:'40px',
    left:19,
    top:45,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 9,
    bottom: 30,
    left: -500,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  totalTextBold:{
    fontSize:'8',
    // paddingLeft:'10',
    fontFamily:'Helvetica-Bold',
  },
  bold:{
    fontSize:'8',
    fontFamily:'Helvetica-Bold',
  },    cell: {
        marginRight:10,

    },
    cellRight: {
        textAlign:"right"
   
    },
    cellLeft: {
        textAlign:"left"
       
    },
    tableRow:{
        display: 'flex',
        flexDirection: 'row',

    },    border:{
        borderBottom:1,
    },
        col1items:{
        display: 'flex',
        flexDirection: 'row',
        width:150
    },
        col1:{
        display: 'flex',
        flexDirection: 'row',
        width:350
    },
    col2:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col3:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col4:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col5:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
        company_adress: {
          fontSize:'8',
    },
        subTitle: {
             fontSize:'9',
            fontFamily:'Helvetica-Bold',
    },
    col400:{
              display: 'flex',
        flexDirection: 'row',
        width:'82%'
    }
});

  export function JcPortalPackageSales(props) {
    const {soInfo, pkgInfo, items,activationInfo,item_details,packages} = props;
    const total = (packages || []).reduce(
  (sum, item) => sum + Number(item[1] || 0),
  0
);

      return (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.title}>JC Portal Wholesale Set</Text>
          <Image
              style={styles.image}
              src={logo}
          />
            <View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Order Information</Text>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Sold To</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.rightName}>{soInfo.delivered_to}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Type</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>Package Sales</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Number</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.transaction_no}</Text></View>
                   </View>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>ID No:</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{activationInfo.idno}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Date</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.trandate}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Package Amount</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.package_amount).format('0,0.00')}</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Shipping Fee</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.shipping_fee).format('0,0.00')}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Grand Total</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(pkgInfo.grand_total).format('0,0.00')}</Text></View>
                   </View>
               </View>
              
              <View style={styles.rightPart}>
                   <Text style={styles.tblTitle}>Delivery Details</Text>
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text>Name</Text></View>
                        <View style={styles.innerRightPart}><Text>{soInfo.delivered_to}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                            <View style={styles.innerLeftPart2}><Text>Email</Text></View>
                        <View style={styles.innerRightPart}><Text>{soInfo.email}</Text></View>
                     </View>
                            <View style={styles.innerBox}>
                                <View style={styles.innerLeftPart2}><Text>Contact Number</Text></View>
                        <View style={styles.innerRightPart}><Text>{soInfo.phone_number}</Text></View>
                     </View>
                       <View style={styles.innerBox}>
                          <View style={styles.innerLeftPart2}><Text>Address</Text></View>
                        <View style={styles.innerRightPart}><Text>{soInfo.delivery_address}</Text></View>
                     </View>
                
                	<View style={styles.brbr}></View>
                
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text>Shipping Status</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{pkgInfo.isdelivered}</Text></View>
                     </View>
                     <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text>Waybill No</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{soInfo.waybill_no}</Text></View>
                     </View>
               </View>
             </View>

      <View style={styles.brbr}></View>    
     <Text style={styles.tblTitle}>Included Set</Text>   
         {/* itemname, qty */}
         {/* <View style={styles.blackBorderUp}></View>
          {items ? (<View>
              {items.map((item=>{
                return(<>
                  <Text style={styles.cvTblHeader10Bold}>{item.pkg_name}</Text>
                  <View style={styles.cvTableHeader}>
                    <Text style={styles.cvTblHeader1Bold}>Item</Text>
                    <Text style={styles.cvTblHeader3Bold}>Qty</Text> 
                  </View> 
                   {item.pkg_items.map((x =>{
                     return( <View style={styles.cvItems}>
                      <Text style={styles.cvTblHeader1}>{x.itemname}</Text>
                      <Text style={styles.cvTblHeader3}>{x.qty}</Text>
                    </View>)
                   }))} 
            </>)
              }))}
          </View>) : (<View></View>)} */}

          {/* eof table */}
   

         {/* <View style={styles.cvItems}>
            <Text style={styles.cvTblHeader1}>Premiere Green Tea</Text>
            <Text style={styles.cvTblHeader3}>1</Text>
         </View>  */}
          {/* Set Details */}
          <View style={[styles.tableRow,styles.paddingTop10,styles.border]}>
              <View style={[styles.tableRow,styles.col400,styles.cellLeft]}>
                  <Text style={[styles.subTitle]}>Set Name</Text>
              </View>
              <View style={[styles.tableRow,styles.col3,styles.cellRight]}>
                  <Text style={[styles.subTitle]}>Qty</Text>
              </View>
          </View>

      { packages&& packages.length > 0 ? 
              packages.map((row, ind) => 
                      <View  key={ind} style={[styles.tableRow,styles.border]}>
                      <View style={[styles.tableRow,styles.col400,styles.cellLeft]}>
                          <Text style={[styles.company_adress]}>{row[0]}</Text>
                      </View>
                      <View style={[styles.tableRow,styles.col3,styles.cellRight]}>
                      <Text style={[styles.company_adress]}>{row[1]}</Text>
                      </View>
                  </View>
              )
          : null} 
                      <View style={[styles.tableRow,styles.cellRight,{width:'100%'}]}>
                      <Text style={[styles.company_adress]}>Total:{total}</Text>
                      </View>

 {/* Item Details */}
 <View style={{marginTop:10}}></View>
                        <View style={[styles.tableRow,styles.paddingTop10,styles.border]}>
                            <View style={[styles.tableRow,styles.col1,styles.cellLeft]}>
                                <Text style={[styles.subTitle,styles.cellLeft,styles.boldFont]}>Description</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col2,styles.cellRight]}>
                                <Text style={[styles.subTitle,styles.cellRight,styles.boldFont]}>Qty</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col3,styles.cellRight]}>
                                <Text style={[styles.subTitle,styles.cellRight,styles.boldFont]}>Unit</Text>
                            </View>
                        </View>
                        {console.log('343',item_details)}
                        {!item_details == "" ? 
                            item_details.map((row, ind) => 
                                <View key={ind} style={[styles.tableRow,styles.border]}>
                                    <View style={[styles.tableRow,styles.col1]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding]}>{row.itemname}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col2]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{Math.abs(row.qty)}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col3]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{row.unit}</Text>
                                    </View>
                                </View>
                            )
                        : null} 
        {/* <View style={styles.blackBorder}></View>   */}
          
 		<View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Payment Information</Text>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPayment}>
                        	<View style={styles.paymentInfo}>
                              	<View style={styles.innerPLeftPart}>
                                   <Text>Payment Status</Text>
                                </View>
                              <View style={styles.innerPRightPart}>
                                <Text>Paid</Text>
                              </View>
                        	</View>

                            <View style={styles.paymentInfo}>
                            {soInfo.payment_mode === 1 ? (<View style={styles.innerPLeftPart}>
                                   <Text>Paypanda Payment</Text>
                                </View>) : (<View style={styles.innerPLeftPart}>
                                   <Text>Asiapay Payment</Text>
                                </View>)}
                              <View style={styles.innerPRightPart}>
                               <Text>{numeral(pkgInfo.grand_total).format('0,0.00')}</Text>
                              </View>
                        	</View>
                        
                             <View style={styles.paymentInfo}>
                              	<View style={styles.innerPLeftPart}>
                                   <Text>Total</Text>
                                </View>
                              <View style={styles.innerPRightPart}>
                                <Text style={styles.totalTextBold}>{numeral(pkgInfo.grand_total).format('0,0.00')}</Text>
                              </View>
                        	</View>
                      </View>
                     
                       <View style={styles.approvedBy}><Text style={styles.approver}>Approved By:</Text></View>
                   </View>
          	  </View>
        </View>
          
  
         <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} / ${totalPages}`
      )} fixed />
        </Page>
      </Document>
       );
  }; 
   